// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2sOw_","large":"styles_large__34OmS"};